import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"

const SocialBtn = ({ url, title }) => {
  return (
    <div className="flex flex-row flex-wrap my-4 share-btn">
      <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`} className="w-1/5 twitter" target="_brank">
        <FontAwesomeIcon icon={faTwitter} />
      </a>
    </div>
  )
} 

export default SocialBtn